<script>
  import Tailwindcss from './Tailwindcss.svelte';
  import { onMount } from "svelte";

  	const URL = 'https://v2-api.sheety.co/c53613b41e6d531340ec88cfa371fb64/futureFlip/flipData'

  	let data = [];
 	let randomTypeFlip;
	let randomTimeFlip;
	let randomObjectFlip;
	let randomRelatedFlip;
	let hidden = true;
	  
	  
	async function getData(){
	    const response = await fetch(URL);
	    data = await response.json();
	    data = data.flipData;

	    let type = 0;
	    let time = 0;
	    let object = 0;
	    let related = 0;

	    let i = 0;

	    for(i = 0; i<data.length; i++){
	    	
	    	if(data[i].type){
	    		type = type+1
	    	}
	    	
	    	if(data[i].time){
	    		time = time+1
	    	}
	    	if(data[i].object){
	    		object = object+1
	    	}
	    	if(data[i].related){
	    		related = related+1
	    	}	  	
	  	};

	  	let randomType = Math.floor(Math.random() * type);
	  	let randomTime = Math.floor(Math.random() * time);
	  	let randomObject = Math.floor(Math.random() * object);
	  	let randomRekated = Math.floor(Math.random() * related);

	  	randomTypeFlip = data[randomType].type;
	  	randomTimeFlip = data[randomTime].time;
	  	randomObjectFlip = data[randomType].object;
	  	randomRelatedFlip = data[randomType].related;
	}

	  //Get Categories
	 onMount(async function() {
	  	getData();
	 });

	function toggleHide(){
		hidden = !hidden;
	}

</script>

<style>

	body{
		margin:0;
	}

	p, button{
	    font-family: 'Roboto', sans-serif;
	}

	.hidden{
		display: none;
	}

</style>

<Tailwindcss />


{#if randomTypeFlip}
	<div class="container max-w-lg text-gray-700">
		<div class="m-4">
			<p class="text-xl sm:text-4xl">In <span class="text-green-600 font-bold">{randomTypeFlip}</span> world</p>
			<p class="text-xl sm:text-4xl"><span class="text-teal-600 font-bold">{randomTimeFlip}</span> in the future</p>
			<p class="text-xl sm:text-4xl">there is <span class="text-blue-600 font-bold">{randomObjectFlip}</span></p>
			<p class="text-xl sm:text-4xl">related to <span class="text-indigo-600 font-bold">{randomRelatedFlip}.</span></p>
			<p class="text-xl sm:text-4xl font-bold text-purple-600 mt-4">What is it?</p>
		</div>
		<div>
			<button class="focus:outline-none m-4 bg-pink-200 py-2 px-4 text-indigo-500 rounded-md" on:click={getData}>
   				Flip again
			</button>		
		</div>
	</div>
{/if}

<button class="focus:outline-none m-4 border border-pink-200 py-2 px-4 text-indigo-500 rounded-md fixed bottom-0" on:click={toggleHide}>
   	About
</button>

<div id="overlay" class:hidden = {hidden} class="text-gray-500 bg-black w-screen h-full top-0 absolute">
	<div class="container overflow-y-scroll bg-black transition-all duration-150">
		<div class="m-4 text-xl sm:text-3xl">
			<p class="mb-4">Futures Flip is a digital workshop tool based on <a class="underline" href="http://situationlab.org/project/the-thing-from-the-future/">The Thing From The Future</a> by Situation Lab.</p> 
			<p class="mb-4">On the page you will see an invitation to imagine something from an alternative future. This is a randomised description generated from a spreadsheet. Hit refresh for a new one.</p> 
			<p class="mb-4">In a workshop each participant can use the description as a prompt to quickly describe and sketch out an idea in response. Before moving onto the next.</p>
			<p class="mb-4">Following the creation of four to five ideas participants should share, discuss, vote and ideally prototype their ideas.</p>
			<p class="mb-4">If you have questions, feedback or ideas then please get in touch with me@julianellerby.com.</p>

			<button class="text-sm focus:outline-none my-4 border border-gray-500 py-2 px-4 text-gray-500 rounded-md" on:click={toggleHide}>
   				Close
			</button>
		</div>
	</div>
</div>




